import React from 'react';
import style from './flightDetailsTripTable.module.scss';
import { FlightDetailsLegTable } from 'acscp/components/legs/flightDetailsLegTable';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { LabeledItem } from 'acscp/components/common/labeledItem';
import { FormatCurrency } from 'acscp/components/common/helpers/formatCurrency';
import { Fragment } from 'react';
import { Quote } from 'acscp/store';

const FlightDetailsTripTable: React.SFC<{
    quote: Quote
    className?: string,
    hasLowerBorder: boolean,
    amexNote: string | null,
}> = props => {
    return (
        <div
            className={style.TripTable}
        >
            {props.quote.trips.map((trip, index) => {
                return (
                    <Fragment key={trip.tripNumber}>
                        <FlightDetailsLegTable
                            legs={trip.legs}
                            className={style.LegsTable}
                            hasLowerBorder={true}
                            tableHeader={{
                                id: 'components.quotes.trip.defaultTripLabel',
                                defaultMessage: `${trip.identifier || 'Trip'} ${trip.includeNumber ? trip.tripNumber + 1 : ''}`,
                            }}
                            departmentKey={props.quote.department}
                            quoteType={props.quote.quoteType}
                        />
                        <LabeledItem
                            includeColon={false}
                            label={
                            <span
                                className={style.InfoHead}
                            >
                                <FormattedMessage
                                    id={'components.quotes.trip.charterPrice'}
                                    defaultMessage={'Charter Price'}
                                />
                            </span>
                            }
                            className={classNames(style.InfoItem)}
                        >
                            <span
                                className={style.InfoChild}
                            >
                                <FormatCurrency currency={props.quote.sellCurrency} price={trip.sellPrice} />
                            </span>
                            <span
                                className={style.AdditionalComments}
                            >
                                {trip.additionalComments}
                            </span>
                            {props.amexNote && index === props.quote.trips.length - 1 &&
                                <div className={style.amexPriceNote}>
                                    {props.amexNote}
                                </div>}
                        </LabeledItem>
                    </Fragment>
                );
            })}
        </div>
    );
};

export { FlightDetailsTripTable };
